import { Component, OnInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Piece } from 'app/models/piece';
import { PiecesService } from 'app/services/pieces/pieces.service';
import { ProjetsService } from 'app/services/projets/projets.service';
import { AwscontrolService } from 'app/services/aws/awscontrol.service';
import Swal from 'sweetalert2';
import { timeout, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-ajouter-pieces',
  templateUrl: './ajouter-pieces.component.html',
  styleUrls: ['./ajouter-pieces.component.scss']
})
export class AjouterPiecesComponent implements OnInit {
  @ViewChild('descriptionTextarea', { static: false }) descriptionTextarea!: ElementRef;
  @ViewChild('pieceImagesInput', { static: false }) pieceImagesInput!: ElementRef;
  @ViewChild('projectSelect') projectSelect!: MatSelect;

  public agenciesProjet: any[] = [];
  public filteredProjects: any[] = [];
  public projectSearchTerm: string = '';
  public isProjectDropdownOpen: boolean = false;

  public pieces: any;
  public idProjet: any;
  piece: Piece;
  selectedFiles: FileList | null = null;
  allAttch: string[] = [];
  public imageProj!: string;
  agenciesApp: any;
  projet: any;
  projetName: string = '';

  public uploadedImages: string[] = [];
  public isLoading: boolean = false;
  public isUploading: boolean = false;
  public uploadProgress: number = 0;
  public submitted: boolean = false;

  // Form fields
  public name: string = '';
  public status: string = '';
  public type: string = '';
  public category: string = '';
  public prixMdt: string = '';
  public surface: string = '';
  public description: string = '';
  public videoUrl: string = '';

  statusOptions = [
    { value: 'DISPONIBLE', label: 'Disponible' },
    { value: 'EN COURS', label: 'En cours' },
    { value: 'VENDU', label: 'Vendu' },
    { value: 'SOLDE', label: 'Soldé' }
  ];

  constructor(
    private projetService: ProjetsService,
    private piecesService: PiecesService,
    private awsService: AwscontrolService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.piece = new Piece();
  }

  ngOnInit() {
    localStorage.removeItem('PieceImg');
    this.allAttch = [];
    this.uploadedImages = [];

    this.idProjet = this.activatedRoute.snapshot.paramMap.get('id');
    console.log('ID Projet from route:', this.idProjet);
    this.getData();

    const savedImages = localStorage.getItem('PieceImg');
    if (savedImages) {
      this.allAttch = JSON.parse(savedImages);
      this.uploadedImages = [...this.allAttch];
    }
  }

  getData() {
    this.projetService.getListProjet().subscribe((data: any) => {
      this.agenciesProjet = Array.isArray(data) ? data : [];
      this.filteredProjects = [...this.agenciesProjet];
      console.log('Liste projets chargée:', this.agenciesProjet);
      
      // After loading projects, ensure the preselected project is set
      if (this.idProjet && this.agenciesProjet.length > 0) {
        const found = this.agenciesProjet.find(p => p.id == this.idProjet || p.id === this.idProjet);
        if (found) {
          this.projetName = found.name;
          console.log('Projet présélectionné:', this.projetName);
        }
      }
      this.cdr.detectChanges();
    });

    if (this.idProjet) {
      this.projetService.getProjet(this.idProjet).subscribe({
        next: (data) => {
          this.projet = data;
          if (!this.projetName) {
            this.projetName = data.name;
          }
          console.log('Projet chargé:', this.projet);
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error('Erreur chargement projet:', err);
        }
      });
    }
  }

  // ========== PROJECT SELECT SEARCH ==========
  onProjectSelectOpened(): void {
    this.isProjectDropdownOpen = true;
    this.projectSearchTerm = '';
    this.filterProjects();
    setTimeout(() => {
      const searchInput = document.querySelector('.project-search-input') as HTMLInputElement;
      if (searchInput) searchInput.focus();
      this.cdr.detectChanges();
    }, 100);
  }

  onProjectSelectClosed(): void {
    this.isProjectDropdownOpen = false;
    this.projectSearchTerm = '';
    this.filterProjects();
    this.cdr.detectChanges();
  }

  filterProjects(): void {
    const term = this.projectSearchTerm?.trim()?.toLowerCase() || '';
    if (!term) {
      this.filteredProjects = [...this.agenciesProjet];
    } else {
      this.filteredProjects = this.agenciesProjet.filter(proj =>
        proj.name.toLowerCase().includes(term)
      );
    }
    console.log('Filtered projects:', this.filteredProjects);
    this.cdr.detectChanges();
  }

  clearProjectSearch(): void {
    this.projectSearchTerm = '';
    this.filterProjects();
    setTimeout(() => {
      const searchInput = document.querySelector('.project-search-input') as HTMLInputElement;
      if (searchInput) searchInput.focus();
      this.cdr.detectChanges();
    }, 0);
  }

  selectProject(project: any): void {
    this.projetName = project.name;
    this.projectSelect.close();
    this.cdr.detectChanges();
  }

  // Compare function for mat-select
  compareProjects(p1: string, p2: string): boolean {
    return p1 === p2;
  }

  // ========== EXISTING METHODS ==========
  validateForm(): boolean {
    return true;
  }

  openImagesSelector(): void {
    if (this.pieceImagesInput && this.pieceImagesInput.nativeElement) {
      this.pieceImagesInput.nativeElement.click();
    }
  }

  onProjectImagesSelected(event: any): void {
    const files = event.target.files;
    if (files && files.length > 0) {
      this.selectedFiles = files;
      this.uploadimg2();
    }
  }

  async uploadimg2() {
    if (!this.selectedFiles) return;

    this.isUploading = true;
    this.uploadProgress = 0;

    const totalFiles = this.selectedFiles.length;
    let uploadedCount = 0;

    Swal.fire({
      title: 'Téléchargement en cours...',
      html: `0/${totalFiles} images`,
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => Swal.showLoading()
    });

    try {
      const files = Array.from(this.selectedFiles);

      for (const file of files) {
        try {
          await this.uploadFileimg2(file);
          uploadedCount++;
          this.uploadProgress = Math.round((uploadedCount / totalFiles) * 100);
          Swal.update({ html: `${uploadedCount}/${totalFiles} images (${this.uploadProgress}%)` });
        } catch (error) {
          console.error(`Erreur upload ${file.name}:`, error);
        }
      }

      Swal.close();
      if (uploadedCount > 0) {
        this.showSuccess(`${uploadedCount} image(s) téléchargée(s) avec succès`);
      }
    } catch (error) {
      console.error('Erreur processus upload:', error);
      Swal.close();
      this.showError('Erreur', 'Une erreur est survenue lors du téléchargement des images');
    } finally {
      this.isUploading = false;
      this.uploadProgress = 0;
      this.selectedFiles = null;
    }
  }

  async uploadFileimg2(file: File) {
    try {
      const folder = 'pieces';
      const response = await this.awsService.uploadFile(file, folder).toPromise();

      if (response.success && response.urls && response.urls.length > 0) {
        const uploadedUrl = response.urls[0];
        this.allAttch.push(uploadedUrl);
        this.uploadedImages.push(uploadedUrl);
        localStorage.setItem('PieceImg', JSON.stringify(this.allAttch));
        return uploadedUrl;
      } else {
        throw new Error(response.error || 'Upload failed');
      }
    } catch (err: any) {
      console.error('Erreur upload image:', err);
      throw err;
    }
  }

  async removeProjectImage(index: number): Promise<void> {
    const imageUrl = this.allAttch[index];
    const result = await Swal.fire({
      title: 'Confirmation',
      text: "Supprimer cette image ?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f44336',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Annuler'
    });

    if (result.isConfirmed) {
      try {
        await this.awsService.deleteFile(imageUrl).toPromise();
        console.log('Image supprimée AWS:', imageUrl);
      } catch (error) {
        console.warn('Impossible de supprimer sur AWS:', error);
      }
      this.allAttch.splice(index, 1);
      this.uploadedImages.splice(index, 1);
      localStorage.setItem('PieceImg', JSON.stringify(this.allAttch));
      this.showSuccess('Image supprimée');
    }
  }

  moveImageUp(index: number): void {
    if (index > 0) {
      [this.allAttch[index], this.allAttch[index - 1]] = [this.allAttch[index - 1], this.allAttch[index]];
      [this.uploadedImages[index], this.uploadedImages[index - 1]] = [this.uploadedImages[index - 1], this.uploadedImages[index]];
      localStorage.setItem('PieceImg', JSON.stringify(this.allAttch));
    }
  }

  moveImageDown(index: number): void {
    if (index < this.allAttch.length - 1) {
      [this.allAttch[index], this.allAttch[index + 1]] = [this.allAttch[index + 1], this.allAttch[index]];
      [this.uploadedImages[index], this.uploadedImages[index + 1]] = [this.uploadedImages[index + 1], this.uploadedImages[index]];
      localStorage.setItem('PieceImg', JSON.stringify(this.allAttch));
    }
  }

  formatText(command: string): void {
    if (this.descriptionTextarea && this.description) {
      const textarea = this.descriptionTextarea.nativeElement;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const selectedText = this.description.substring(start, end);

      let formattedText = '';
      switch (command) {
        case 'bold': formattedText = `<strong>${selectedText}</strong>`; break;
        case 'italic': formattedText = `<em>${selectedText}</em>`; break;
        case 'underline': formattedText = `<u>${selectedText}</u>`; break;
        case 'list': formattedText = `<ul><li>${selectedText}</li></ul>`; break;
      }

      const newText = this.description.substring(0, start) + formattedText + this.description.substring(end);
      this.description = newText;

      setTimeout(() => {
        textarea.focus();
        textarea.setSelectionRange(start + formattedText.length, start + formattedText.length);
      }, 0);
    }
  }

  onSubmit() {
    this.submitted = true;

    if (this.isLoading || this.isUploading) {
      this.showWarning('Veuillez patienter', 'Des opérations sont en cours');
      return;
    }

    if (!this.idProjet) {
      this.showError('Erreur', 'ID du projet manquant. Impossible de créer l\'appartement.');
      return;
    }

    this.isLoading = true;

    Swal.fire({
      title: 'Création en cours...',
      html: 'Ajout de l\'appartement, veuillez patienter',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => Swal.showLoading()
    });

    const pieceData = {
      name: this.name || 'Sans nom',
      status: this.status || 'DISPONIBLE',
      projetName: this.projetName,
      category: this.category || '',
      type: this.type || '',
      prixMdt: this.prixMdt || '0',
      surface: this.surface || '0',
      description: this.description || '',
      photos: this.allAttch || [],
      videoUrl: this.videoUrl?.trim() ? this.videoUrl : null
    };

    console.log('Données envoyées:', pieceData);
    console.log('ID Projet utilisé:', this.idProjet);

    this.piecesService.createPiece(pieceData, this.idProjet)
      .pipe(
        timeout(30000),
        catchError(err => {
          console.error('Erreur dans l\'appel createPiece:', err);
          return throwError(() => err);
        })
      )
      .subscribe({
        next: (response) => {
          console.log('Réponse du serveur:', response);
          Swal.close();
          this.showSuccessAndRedirect('Appartement créé avec succès!');
        },
        error: (error: any) => {
          Swal.close();
          this.isLoading = false;
          console.error('Erreur détaillée:', error);

          let errorMessage = 'Échec de la création de l\'appartement';

          if (error.name === 'TimeoutError' || (error.message && error.message.includes('timeout'))) {
            errorMessage = 'Le serveur a mis trop de temps à répondre. Veuillez réessayer.';
          } else if (error instanceof HttpErrorResponse) {
            errorMessage = `Erreur ${error.status}: ${error.error?.message || error.message || 'Problème de communication'}`;
          } else if (error.message) {
            errorMessage = error.message;
          }

          this.showError('Erreur', errorMessage);
        },
        complete: () => {
          console.log('Observable createPiece complété');
        }
      });
  }

  showSuccessAndRedirect(message: string): void {
    Swal.fire({
      icon: 'success',
      title: 'Succès!',
      text: message,
      timer: 2000,
      showConfirmButton: false
    }).then(() => {
      localStorage.removeItem('PieceImg');
      this.allAttch = [];
      this.uploadedImages = [];
      this.resetForm();
      this.navigateBack();
    });
  }

  resetForm(): void {
    this.name = '';
    this.status = '';
    this.type = '';
    this.category = '';
    this.prixMdt = '';
    this.surface = '';
    this.description = '';
    this.videoUrl = '';
    this.submitted = false;
  }

  navigateBack(): void {
    localStorage.removeItem('PieceImg');
    if (this.idProjet) {
      this.router.navigate(['list-appartement/' + this.idProjet]);
    } else {
      this.router.navigate(['/list-appartement']);
    }
  }

  showSuccess(message: string): void {
    Swal.fire({ icon: 'success', title: message, timer: 1500, showConfirmButton: false });
  }

  showError(title: string, message: string): void {
    Swal.fire({ icon: 'error', title, text: message, confirmButtonColor: '#3f51b5' });
  }

  showWarning(title: string, message: string): void {
    Swal.fire({ icon: 'warning', title, text: message });
  }

  getCategories(): string[] {
    return this.projet?.categoryList || [];
  }

  trackByProject(index: number, project: any): string {
    return project.name;
  }
}